// src/app/components/cita/cita.component.ts
import { Component, inject, OnInit, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { GLOBAL } from '../../services/GLOBAL';
import { CitaService } from '../../services/cita.service';
import { Router } from '@angular/router';
import { MatStepper } from '@angular/material/stepper';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import Fuse from 'fuse.js';
import type { IFuseOptions } from 'fuse.js';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map, Observable } from 'rxjs';
import { StepperOrientation } from '@angular/material/stepper';


declare var grecaptcha: any;

interface RangoBusqueda {
  fecha_inicio: string;
  fecha_fin: string;
}

interface DisponibilidadCita {
  agendas: string[];
  sucursales?: string[];
  minutos?: string;
}

interface ResumenCita {
  especialidad: string;
  servicio: string;
  sede: string;
  fecha: string;
  hora: string;
  paciente: {
    nombre: string | null;
    primerApellido: string | null;
    segundoApellido: string | null;
    correo: string | null;
    telefono: string | null;
    cedula: string | null;
  };
}

@Component({
  selector: 'app-cita',
  templateUrl: './cita.component.html',
  styleUrls: ['./cita.component.css']
})
export class CitaComponent implements OnInit {
  @ViewChild('cedula') cedula: any;
  @ViewChild('stepper', { read: ElementRef }) stepperEl?: ElementRef<HTMLElement>;
  public global = GLOBAL;

  public servicios: { [key: string]: any } = {};
  public especialidades = new Map<string, Array<{ key: string; value: any }>>();
  public especialidadSeleccionada: string | null = null;
  public selectedServicio: { key: string; value: any } | null = null;

  public sucursalesDetalle: { [key: string]: any } = {};
  public sucursales: Array<{ key: string; label: string; value: any }> = [];
  public sucursalSeleccionada: { key: string; label: string; value: any } | null = null;
  public sucursalSeleccionadaKey: string | null = null;

  public disponibilidadFechas: string[] = [];
  public horariosPorFecha: { [fecha: string]: string[] } = {};
  public horariosDisponibles: string[] = [];
  public citasPorFechaHora: { [fechaHora: string]: DisponibilidadCita } = {};
  public fechaSeleccionada: string | null = null;
  public horaSeleccionada: string | null = null;
  public citaFechaHoraSeleccionada: string | null = null;
  public agendasParaRegistro: string[] = [];

  public rangoBusqueda: RangoBusqueda | null = null;
  public fechaMinimaBusqueda: string | null = null;
  public fechaMaximaBusqueda: string | null = null;
  public minDateStruct: NgbDateStruct | null = null;
  public maxDateStruct: NgbDateStruct | null = null;
  public selectedDateStruct: NgbDateStruct | null = null;
  public tomorrow: string | null = null;

  public btnStart = true;
  public btnClick = true;
  public btnSpinner = false;
  public spinner = false;
  public spinner2 = false;
  public horario = false;
  public emptyHorarios = false;
  public lugarSelected = false;

  public errorStep1: string | null = null;
  public errorAgenda: string | null = null;
  public errorCita: string | null = null;
  public confirmacionCita: string | null = null;

  public nombrePaciente: string | null = null;
  public cedulaPaciente: string | null = null;
  public correoPaciente: string | null = null;
  public sexoPaciente: string | null = null;
  public telefonoPaciente: string | null = null;
  public expediente: string | null = null;
  public fechaNacimiento: string | null = null;
  public primerApellidoPaciente: string | null = null;
  public segundoApellidoPaciente: string | null = null;
  public tipoIdentificacionPaciente: string | null = null;
  public resumenCita: ResumenCita | null = null;
  public formBloqueado = false;

  public alertSede = true;

  public showcompleteForm = false;
  public obteniendoDatosPaciente = false;
  public disablePatientForm = true;
  public pacienteNoEncontrado = false;

  private browserRecaptchaKey = this.global.browserRecaptchaKey;
  public userMail = this.global.userMail;
  private availableDateSet: Set<string> = new Set();
  private serviciosArray: Array<{ key: string; value: any }> = [];
  private fuse: Fuse<{ key: string; value: any }> | null = null;
  private readonly fuseOptions: IFuseOptions<{ key: string; value: any }> = {
    includeScore: true,
    threshold: 0.32,
    ignoreLocation: true,
    minMatchCharLength: 1,
    keys: [
      { name: 'value.nombre', weight: 0.5 },
      { name: 'value.servicio_api_sinonimos', weight: 0.4 },
      { name: 'value.especialidad', weight: 0.2 },
      { name: 'value.especialservicio_api_descripcionidad', weight: 0.1 },
      { name: 'value.observaciones', weight: 0.1 },
      { name: 'value.preparacion', weight: 0.1 }
    ]
  };
  public terminoBusqueda = '';
  public resultadosBusqueda: Array<{ key: string; value: any }> = [];
  public buscandoServicios = false;

  public isDateDisabled = (date: NgbDateStruct): boolean => {
    const dateStr = this.dateStructToString(date);
    return !dateStr || !this.availableDateSet.has(dateStr);
  };

  constructor(
    private _citaService: CitaService,
    private router: Router,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.resetPaciente(true);
    const tomorrowDate = new Date();
    tomorrowDate.setDate(tomorrowDate.getDate() + 1);
    this.tomorrow = tomorrowDate.toISOString().split('T')[0];
  }

  listarServicios(): void {
    this.btnClick = false;
    this.btnSpinner = true;
    this.btnStart = true;
    this.servicios = {};
    this.especialidades.clear();
    this.especialidadSeleccionada = null;
    this.selectedServicio = null;
    this.serviciosArray = [];
    this.fuse = null;
    this.terminoBusqueda = '';
    this.resultadosBusqueda = [];
    this.buscandoServicios = false;
    this.resetStep2();
    this.resetPaciente(true);
    this.confirmacionCita = null;
    this.errorCita = null;
    this.errorStep1 = null;

    const recaptchaAction = 'ListarServicios';
    grecaptcha.enterprise.ready(async () => {
      const token = await grecaptcha.enterprise.execute(this.browserRecaptchaKey, { action: recaptchaAction });
      const data = {
        recaptchaToken: token,
        recaptchaAction
      };
      (await this._citaService.listarServicios(data)).subscribe(
        response => {
          this.servicios = response.servicios || {};
          this.especialidades = new Map<string, Array<{ key: string; value: any }>>();
          this.serviciosArray = [];
          Object.keys(this.servicios).forEach(key => {
            const original = this.servicios[key] || {};
            const especialidadNormalizada = (original.especialidad || '').trim() || 'OTROS SERVICIOS';
            const servicioNormalizado = {
              ...original,
              nombre: (original.nombre || '').trim(),
              observaciones: (original.observaciones || '').toString(),
              preparacion: (original.preparacion || '').toString(),
              especialidad: especialidadNormalizada,
              especialservicio_api_descripcionidad: (original.especialservicio_api_descripcionidad || '').toString(),
              servicio_api_sinonimos: (original.servicio_api_sinonimos || '').toString()
            };
            const entry = { key, value: servicioNormalizado };
            const list = this.especialidades.get(especialidadNormalizada) || [];
            list.push(entry);
            this.especialidades.set(especialidadNormalizada, list);
            this.serviciosArray.push(entry);
          });
          this.serviciosArray.sort((a, b) =>
            a.value.nombre.localeCompare(b.value.nombre, 'es', { sensitivity: 'base' })
          );
          this.especialidades.forEach(list =>
            list.sort((a, b) => a.value.nombre.localeCompare(b.value.nombre, 'es', { sensitivity: 'base' }))
          );
          this.fuse = this.serviciosArray.length
            ? new Fuse(this.serviciosArray, this.fuseOptions)
            : null;
          this.btnStart = false;
          this.btnSpinner = false;
        },
        error => {
          this.btnSpinner = false;
          if (error?.error?.message) {
            this.errorStep1 = error.error.message;
          } else if (error?.message) {
            this.errorStep1 = error.message;
          } else {
            this.errorStep1 = 'No pudimos comunicarnos con el servidor, intente mas tarde';
          }
        }
      );
    });
  }

  seleccionarEspecialidad(nombre: string): void {
    if (this.spinner2) {
      return;
    }
    if (this.especialidadSeleccionada === nombre) {
      return;
    }
    this.especialidadSeleccionada = nombre;
    this.selectedServicio = null;
    this.limpiarBusqueda();
    this.resetStep2();
    this.errorAgenda = null;
  }

  obtenerServiciosDeEspecialidad(): Array<{ key: string; value: any }> {
    if (!this.especialidadSeleccionada) {
      return [];
    }
    return this.especialidades.get(this.especialidadSeleccionada) || [];
  }

  volverEspecialidades(): void {
    this.especialidadSeleccionada = null;
    this.selectedServicio = null;
    this.resetStep2(true);
  }

  seleccionarServicio(servicio: { key: string; value: any }, stepper: MatStepper): void {
    if (this.spinner2) {
      return;
    }
    this.selectedServicio = servicio;
    this.especialidadSeleccionada = servicio?.value?.especialidad || this.especialidadSeleccionada;
    this.limpiarBusqueda();
    this.errorAgenda = null;
    this.listarAgendas(stepper);
  }

  listarAgendas(stepper?: MatStepper | null): void {
    if (!this.selectedServicio) {
      this.errorAgenda = 'Seleccione un servicio para continuar';
      return;
    }
    this.alertSede = false;
    this.spinner2 = true;
    this.errorAgenda = null;
    this.lugarSelected = false;
    this.sucursales = [];
    this.sucursalesDetalle = {};
    this.sucursalSeleccionada = null;
    this.sucursalSeleccionadaKey = null;
    this.disponibilidadFechas = [];
    this.horariosPorFecha = {};
    this.horariosDisponibles = [];
    this.citasPorFechaHora = {};
    this.fechaSeleccionada = null;
    this.horaSeleccionada = null;
    this.citaFechaHoraSeleccionada = null;
    this.agendasParaRegistro = [];
    this.emptyHorarios = false;
    this.rangoBusqueda = null;
    this.fechaMinimaBusqueda = null;
    this.fechaMaximaBusqueda = null;
    this.minDateStruct = null;
    this.maxDateStruct = null;
    this.selectedDateStruct = null;
    this.availableDateSet.clear();
    this.resumenCita = null;
    this.formBloqueado = false;
    this.confirmacionCita = null;
    this.errorCita = null;

    const recaptchaAction = 'ListarSucursales';
    grecaptcha.enterprise.ready(async () => {
      const token = await grecaptcha.enterprise.execute(this.browserRecaptchaKey, { action: recaptchaAction });
      const data = {
        recaptchaToken: token,
        recaptchaAction,
        servicio: this.selectedServicio ? this.selectedServicio.key : ''
      };
      this._citaService.listarAgendas(data).subscribe(
        response => {
          this.spinner2 = false;
          this.sucursalesDetalle = response.agenda || {};
          this.rangoBusqueda = response.rangoBusqueda || null;
          this.setRangoBusqueda(this.rangoBusqueda);
          this.sucursales = Object.keys(this.sucursalesDetalle).map(key => ({
            key,
            label: key.split('-')[0]?.trim() || key,
            value: this.sucursalesDetalle[key]
          }));
          this.lugarSelected = this.sucursales.length > 0;
          if (!this.lugarSelected) {
            this.errorAgenda = 'No hay ubicaciones disponibles para este servicio en el proximo mes.';
          }
        },
        error => {
          this.spinner2 = false;
          if (error?.error?.message) {
            this.errorAgenda = error.error.message;
          } else {
            this.errorAgenda = 'No pudimos obtener las ubicaciones disponibles, intente nuevamente.';
          }
        }
      );
    });
    if (stepper) {
      stepper.next();
    }
  }

  onBuscarServicios(termino: string): void {
    this.terminoBusqueda = termino;
    const query = termino.trim();
    if (!query) {
      this.resultadosBusqueda = [];
      this.buscandoServicios = false;
      return;
    }
    if (!this.fuse) {
      this.resultadosBusqueda = [];
      this.buscandoServicios = false;
      return;
    }
    this.especialidadSeleccionada = null;
    this.selectedServicio = null;
    const resultados = this.fuse.search(query, { limit: 30 });
    this.resultadosBusqueda = resultados.map(res => res.item);
    this.buscandoServicios = true;
  }

  limpiarBusqueda(): void {
    if (this.terminoBusqueda === '' && !this.buscandoServicios) {
      return;
    }
    this.terminoBusqueda = '';
    this.resultadosBusqueda = [];
    this.buscandoServicios = false;
  }

  onSucursalSeleccionadaChange(sucursalKey: string, stepper?: MatStepper | null): void {
    this.horario = false;
    this.errorAgenda = null;
    this.disponibilidadFechas = [];
    this.horariosPorFecha = {};
    this.horariosDisponibles = [];
    this.citasPorFechaHora = {};
    this.fechaSeleccionada = null;
    this.horaSeleccionada = null;
    this.citaFechaHoraSeleccionada = null;
    this.agendasParaRegistro = [];
    this.emptyHorarios = false;
    this.confirmacionCita = null;
    this.errorCita = null;
    this.resetPaciente(true);
    this.selectedDateStruct = null;
    this.availableDateSet.clear();

    this.sucursalSeleccionadaKey = sucursalKey || null;
    const seleccion = this.sucursales.find(s => s.key === sucursalKey) || null;
    this.sucursalSeleccionada = seleccion;

    if (!seleccion) {
      this.sucursalSeleccionada = null;
      return;
    }

    const agendaIds = Object.keys(seleccion.value || {});
    if (agendaIds.length === 0) {
      this.emptyHorarios = true;
      this.errorAgenda = 'La ubicacion seleccionada no tiene agendas activas en este rango.';
      return;
    }

    this.cargarDisponibilidad(agendaIds);
    if (stepper) {
      stepper.next();
    }
  }

  onSucursalCardClicked(sucursalKey: string, stepper: MatStepper): void {
    if (this.spinner2) {
      return;
    }
    this.onSucursalSeleccionadaChange(sucursalKey, stepper);
  }

  onDatepickerChange(date: NgbDateStruct | null): void {
    const fecha = this.dateStructToString(date);
    if (!fecha || !this.availableDateSet.has(fecha)) {
      this.onFechaSeleccionada(null);
      return;
    }
    this.onFechaSeleccionada(fecha);
  }

  onFechaSeleccionada(fecha: string | null): void {
    this.fechaSeleccionada = fecha || null;
    this.selectedDateStruct = this.dateStringToStruct(this.fechaSeleccionada);
    this.horaSeleccionada = null;
    this.citaFechaHoraSeleccionada = null;
    this.agendasParaRegistro = [];
    this.confirmacionCita = null;
    this.errorCita = null;
    this.resumenCita = null;
    this.formBloqueado = false;
    this.errorAgenda = null;

    if (!fecha) {
      this.horariosDisponibles = [];
      this.selectedDateStruct = null;
      return;
    }

    if (this.disponibilidadFechas.length > 0 && !this.disponibilidadFechas.includes(fecha)) {
      this.horariosDisponibles = [];
      this.errorAgenda = 'Seleccione una fecha disponible.';
      this.selectedDateStruct = null;
      return;
    }

    this.horariosDisponibles = this.horariosPorFecha[fecha] || [];
    this.emptyHorarios = this.horariosDisponibles.length === 0;
    if (this.emptyHorarios) {
      this.errorAgenda = 'No hay horarios disponibles para la fecha seleccionada.';
    }
  }

  onHoraSeleccionada(hora: string, stepper?: MatStepper | null): void {
    this.horaSeleccionada = hora || null;
    this.citaFechaHoraSeleccionada = null;
    this.agendasParaRegistro = [];
    this.confirmacionCita = null;
    this.errorCita = null;
    this.resumenCita = null;
    this.formBloqueado = false;

    if (!this.fechaSeleccionada || !hora) {
      return;
    }

    const llave = `${this.fechaSeleccionada} ${hora}`;
    this.citaFechaHoraSeleccionada = llave;
    const detalle = this.citasPorFechaHora[llave];
    if (detalle && detalle.agendas && detalle.agendas.length > 0) {
      this.agendasParaRegistro = detalle.agendas;
      this.errorAgenda = null;
    } else {
      this.errorAgenda = 'No se pudo identificar la agenda para la hora seleccionada.';
    }

    if (this.horaSeleccionada && this.agendasParaRegistro.length > 0) {
      this.resetPaciente(false);
    }

    if (stepper && this.horaSeleccionada && this.agendasParaRegistro.length > 0) {
      stepper.next();
    }
  }

  async completarCitaForm(): Promise<void> {
    if (!this.cedulaPaciente) {
      return;
    }
    this.showcompleteForm = false;
    this.disablePatientForm = true;
    this.resetPaciente(true);
    this.pacienteNoEncontrado = false;
    this.obteniendoDatosPaciente = true;

    const recaptchaAction = 'CompletarForm';
    const token = await grecaptcha.enterprise.execute(this.browserRecaptchaKey, { action: recaptchaAction });
    const data = {
      recaptchaToken: token,
      recaptchaAction,
      cedula: this.cedulaPaciente
    };
    this._citaService.getDatosPacientes(data).subscribe(
      response => {
        this.pacienteNoEncontrado = false;
        const paciente = response.datosPaciente;
        if (paciente) {
          this.nombrePaciente = paciente.nombre || null;
          this.correoPaciente = paciente.correo || null;
          this.expediente = paciente.expediente || null;
          this.sexoPaciente = paciente.sexo || null;
          this.telefonoPaciente = paciente.telefono || paciente.telefono2 || null;
          this.fechaNacimiento = paciente.fecha_nacimiento || null;
          this.primerApellidoPaciente = paciente.primer_apellido || null;
          this.segundoApellidoPaciente = paciente.segundo_apellido || null;
          this.tipoIdentificacionPaciente = paciente.tipo || paciente.tipo_identificacion || null;
        }
        this.disablePatientForm = true;
        this.showcompleteForm = true;
        this.obteniendoDatosPaciente = false;
      },
      error => {
        this.pacienteNoEncontrado = error?.status === 404;
        this.disablePatientForm = true;
        this.showcompleteForm = true;
        this.obteniendoDatosPaciente = false;
      }
    );
  }

  async agendarCita(): Promise<void> {
    this.errorCita = null;
    this.confirmacionCita = null;

    if (!this.selectedServicio || !this.citaFechaHoraSeleccionada || this.agendasParaRegistro.length === 0) {
      this.errorCita = 'Seleccione una ubicacion, fecha y hora disponibles antes de continuar.';
      return;
    }

    if (!this.nombrePaciente || !this.primerApellidoPaciente || !this.cedulaPaciente || !this.correoPaciente) {
      this.errorCita = 'No se pudieron completar los datos del paciente. Intente nuevamente.';
      return;
    }

    const recaptchaAction = 'AgendarCita';
    this.spinner = true;
    const token = await grecaptcha.enterprise.execute(this.browserRecaptchaKey, { action: recaptchaAction });
    const data = {
      recaptchaToken: token,
      recaptchaAction,
      servicio: this.selectedServicio.key,
      fecha: this.citaFechaHoraSeleccionada,
      agendas: this.agendasParaRegistro,
      nombre: this.nombrePaciente,
      cedula: this.cedulaPaciente,
      correo: this.correoPaciente,
      sexo: this.sexoPaciente ? Number(this.sexoPaciente) : undefined,
      telefono: this.telefonoPaciente || undefined,
      expediente: this.expediente || undefined,
      fechaNacimiento: this.fechaNacimiento || undefined,
      primerApellido: this.primerApellidoPaciente,
      segundoApellido: this.segundoApellidoPaciente || undefined,
      tipoIdentificacion: this.tipoIdentificacionPaciente || undefined
    };

    (await this._citaService.registro(data)).subscribe(
      response => {
        this.spinner = false;
        const cita = response.cita || {};
        if (cita.api_cita_creada) {
          this.confirmacionCita = cita.api_cita_creada;
          this.prepararResumenCita();
        } else if (cita.status === 'exito' && cita.message) {
          this.confirmacionCita = cita.message;
          this.prepararResumenCita();
        } else {
          this.errorCita = 'Espacio no disponible';
          this.resumenCita = null;
          this.formBloqueado = true;
        }
      },
      () => {
        this.spinner = false;
        this.errorCita = 'Error de comunicacion';
        this.resumenCita = null;
        this.formBloqueado = true;
      }
    );
  }

  resetStep2(clearServicio: boolean = false): void {
    if (clearServicio) {
      this.selectedServicio = null;
      this.especialidadSeleccionada = null;
    }
    this.sucursalSeleccionadaKey = null;
    this.sucursalesDetalle = {};
    this.sucursales = [];
    this.sucursalSeleccionada = null;
    this.lugarSelected = false;
    this.spinner2 = false;
    this.horario = false;
    this.errorAgenda = null;
    this.disponibilidadFechas = [];
    this.horariosPorFecha = {};
    this.horariosDisponibles = [];
    this.citasPorFechaHora = {};
    this.fechaSeleccionada = null;
    this.horaSeleccionada = null;
    this.citaFechaHoraSeleccionada = null;
    this.agendasParaRegistro = [];
    this.emptyHorarios = false;
    this.rangoBusqueda = null;
    this.fechaMinimaBusqueda = null;
    this.fechaMaximaBusqueda = null;
    this.minDateStruct = null;
    this.maxDateStruct = null;
    this.selectedDateStruct = null;
    this.availableDateSet.clear();
    this.limpiarBusqueda();
  }

  volver(): void {
    const currentRoute = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentRoute]);
    });
  }

  back(): void {
    this.errorCita = null;
    this.formBloqueado = false;
    this.confirmacionCita = null;
    this.resumenCita = null;
  }

  validateChar(event: Event): void {
    const e = event as KeyboardEvent;
    const currentValue = this.cedula?.nativeElement?.value;
    if (currentValue != null) {
      if (currentValue.match(/[^\w\s]/gi) === null) {
        return;
      }
      e.preventDefault();
      const sanitized = currentValue.replace(/[^\w\s]/gi, '');
      this.renderer.setProperty(this.cedula.nativeElement, 'value', sanitized);
      if (this.cedulaPaciente) {
        this.cedulaPaciente = this.cedulaPaciente.replace(/[^\w\s]/gi, '');
      }
    }
  }

  getSexoLabel(value: string | number | null): string {
    if (value === undefined || value === null) {
      return '';
    }
    const normalized = String(value).trim();
    if (normalized === '1') {
      return 'Mujer';
    }
    if (normalized === '2') {
      return 'Hombre';
    }
    return normalized;
  }

  private setRangoBusqueda(rango: RangoBusqueda | null): void {
    if (rango && rango.fecha_inicio && rango.fecha_fin) {
      this.fechaMinimaBusqueda = rango.fecha_inicio.split(' ')[0];
      this.fechaMaximaBusqueda = rango.fecha_fin.split(' ')[0];
    } else {
      const inicio = new Date();
      inicio.setDate(inicio.getDate() + 1);
      const fin = new Date(inicio);
      fin.setMonth(fin.getMonth() + 1);
      this.fechaMinimaBusqueda = inicio.toISOString().split('T')[0];
      this.fechaMaximaBusqueda = fin.toISOString().split('T')[0];
    }
    this.minDateStruct = this.dateStringToStruct(this.fechaMinimaBusqueda);
    this.maxDateStruct = this.dateStringToStruct(this.fechaMaximaBusqueda);
  }

  private cargarDisponibilidad(agendaIds: string[]): void {
    if (!this.selectedServicio) {
      return;
    }
    this.horario = true;
    this.errorAgenda = null;
    const recaptchaAction = 'ListarCitas';
    grecaptcha.enterprise.ready(async () => {
      const token = await grecaptcha.enterprise.execute(this.browserRecaptchaKey, { action: recaptchaAction });
      const data: any = {
        recaptchaToken: token,
        recaptchaAction,
        servicio: this.selectedServicio ? this.selectedServicio.key : '',
        agendas: agendaIds
      };
      if (this.rangoBusqueda) {
        data.fecha_inicio = this.rangoBusqueda.fecha_inicio;
        data.fecha_fin = this.rangoBusqueda.fecha_fin;
      }
      this._citaService.listarCitas(data).subscribe(
        response => {
          this.horario = false;
          const disponibilidad = response.disponibilidad || {};
          this.disponibilidadFechas = disponibilidad.fechas || [];
          this.horariosPorFecha = disponibilidad.horariosPorFecha || {};
          this.citasPorFechaHora = disponibilidad.citasPorFechaHora || {};
          this.availableDateSet = new Set(this.disponibilidadFechas);
          this.horariosDisponibles = [];
          this.emptyHorarios = this.disponibilidadFechas.length === 0;
          if (this.emptyHorarios) {
            this.errorAgenda = 'No hay horarios disponibles en el proximo mes para esta ubicacion.';
          }
          if (this.fechaSeleccionada && !this.disponibilidadFechas.includes(this.fechaSeleccionada)) {
            this.fechaSeleccionada = null;
            this.selectedDateStruct = null;
            this.horaSeleccionada = null;
            this.citaFechaHoraSeleccionada = null;
            this.agendasParaRegistro = [];
          }
          if (this.fechaMinimaBusqueda) {
            this.selectedDateStruct = this.dateStringToStruct(this.fechaSeleccionada);
          }
        },
        error => {
          this.horario = false;
          if (error?.error?.message) {
            this.errorAgenda = error.error.message;
          } else {
            this.errorAgenda = 'Error de comunicacion con el servidor, intente de nuevo';
          }
          this.availableDateSet.clear();
        }
      );
    });
  }

  private resetPaciente(preserveCedula: boolean): void {
    const cedula = preserveCedula ? this.cedulaPaciente : null;
    this.nombrePaciente = null;
    this.correoPaciente = null;
    this.expediente = null;
    this.sexoPaciente = null;
    this.telefonoPaciente = null;
    this.fechaNacimiento = null;
    this.primerApellidoPaciente = null;
    this.segundoApellidoPaciente = null;
    this.tipoIdentificacionPaciente = null;
    this.showcompleteForm = false;
    this.disablePatientForm = true;
    this.obteniendoDatosPaciente = false;
    this.pacienteNoEncontrado = false;
    if (!preserveCedula) {
      this.cedulaPaciente = null;
    } else {
      this.cedulaPaciente = cedula;
    }
  }

  private dateStringToStruct(date: string | null): NgbDateStruct | null {
    if (!date) {
      return null;
    }
    const [yearStr, monthStr, dayStr] = date.split('-');
    const year = Number(yearStr);
    const month = Number(monthStr);
    const day = Number(dayStr);
    if (!year || !month || !day) {
      return null;
    }
    return { year, month, day };
  }

  private dateStructToString(date: NgbDateStruct | null): string | null {
    if (!date) {
      return null;
    }
    const month = String(date.month).padStart(2, '0');
    const day = String(date.day).padStart(2, '0');
    return `${date.year}-${month}-${day}`;
  }

  private prepararResumenCita(): void {
    this.resumenCita = {
      especialidad: this.selectedServicio?.value?.especialidad || '',
      servicio: this.selectedServicio?.value?.nombre || '',
      sede: this.sucursalSeleccionada?.label || '',
      fecha: this.formatearFecha(this.fechaSeleccionada),
      hora: this.horaSeleccionada || '',
      paciente: {
        nombre: this.nombrePaciente,
        primerApellido: this.primerApellidoPaciente,
        segundoApellido: this.segundoApellidoPaciente,
        correo: this.correoPaciente,
        telefono: this.telefonoPaciente,
        cedula: this.cedulaPaciente
      }
    };
    this.formBloqueado = true;
  }

  private formatearFecha(fecha: string | null): string {
    if (!fecha) {
      return '';
    }
    const date = new Date(fecha + 'T00:00:00');
    if (isNaN(date.getTime())) {
      return fecha;
    }
    return date.toLocaleDateString('es-CR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
  }

  private bpo = inject(BreakpointObserver);

  // Vertical en móviles (Handset), horizontal en el resto
  stepperOrientation: Observable<StepperOrientation> =
    this.bpo.observe(Breakpoints.Handset).pipe(
      map(state => (state.matches ? 'vertical' : 'horizontal'))
    );

  /** Scrolla el elemento objetivo para que quede ~200px debajo del top (siempre). */
scrollToTop200(target: string | HTMLElement | null, ms = 600): void {
  const el = typeof target === 'string'
    ? document.querySelector(target) as HTMLElement | null
    : (target as HTMLElement | null);

  if (!el) return;

  el.classList.add('once-snap-200');
  el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  window.setTimeout(() => el.classList.remove('once-snap-200'), ms);
}



}
